import { Box, Button } from '@modusign/design-system';

import warningIcon from '@app/assets/icons/icon-warning-white-h17.svg';
import EnhancedToolTip from '@app/components/EnhancedToolTip';

interface ContractLinkCreateFooterProps {
  backButtonText: string;
  disabled?: boolean;
  nextButtonText: string;
  tooltipText?: string;
  onBackStep: () => void;
  onNextStep: () => void;
}

function ContractLinkCreateFooter({
  backButtonText,
  disabled,
  nextButtonText,
  tooltipText,
  onBackStep,
  onNextStep,
}: ContractLinkCreateFooterProps) {
  return (
    <Box
      backgroundColor="darkGray700"
      bottom={0}
      color="white"
      left={0}
      p="12px 25px 0px"
      sx={{
        whiteSpace: 'nowrap',
        zIndex: 500, // $z-index-fixed-layout
      }}
      width="100%"
    >
      <Box mb={4} sx={{ minHeight: '38px' }} textAlign="center">
        <Button
          backgroundColor="darkGray500"
          color="lightGray800"
          height={48}
          mr={2}
          sx={{
            borderColor: 'darkGray500',
            '&:hover': {
              backgroundColor: 'darkGray400',
            },
          }}
          width={180}
          onClick={onBackStep}
        >
          {backButtonText}
        </Button>
        <Box
          className="TemplateFieldFooter__next-step-button-container"
          display="inline-block"
          position="relative"
          sx={{
            '&:hover .ContractLinkCreateFooter__next-step-button-tooltip': {
              display: 'block',
            },
          }}
          width="180px"
        >
          <Button
            disabled={disabled}
            height={48}
            variant="primary"
            width={180}
            onClick={onNextStep}
          >
            {nextButtonText}
          </Button>
          {disabled && tooltipText && (
            <Box
              className="ContractLinkCreateFooter__next-step-button-tooltip"
              display="none"
              left="50%"
              position="absolute"
              top="5px"
              width="360px"
            >
              <EnhancedToolTip arrowDirection="bottom">
                <p>
                  <Box as="span" margin="2px 4px 0" sx={{ float: 'left' }}>
                    <img alt="" src={warningIcon} />
                    &nbsp;
                  </Box>
                  {tooltipText}
                </p>
              </EnhancedToolTip>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default ContractLinkCreateFooter;
